// extracted by mini-css-extract-plugin
module.exports = {"access-app-title":"_1m6kpaLhhTxdFqc9fBMDRk","access-app-description":"_3CzJlLOZXQT5Fhy6No7LDX","partial-checked":"YaaCTynjHt6XKK1umxHBw"};